<template>
    <div class="container flex-grow-1 align-content-center d-flex align-items-center">
        <div class="text-center flex-grow-1 align-items-center d-flex flex-column">
            <div class="half-circle-spinner mb-3">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
            </div>
            <h4 class="text-muted text-bold">{{message}}</h4>
            <div class="text-muted small">{{detail}}</div>
            <div v-if="showReload && checkPerformed" class="text-muted small mt-3">If this error persists, please contact technical support.</div>
            <button v-if="showReload" type="button" class="btn btn-small btn-secondary mt-2" @click="handleReload">Reload</button>
        </div>
    </div>
</template>

<script>
const messages = [
    {
        text: 'Calculating Assessment Results',
        detail: '\xa0',
        duration: 4,
    },
    {
        text: 'Calculating Assessment Results',
        detail: 'This could take a minute...',
        duration: 6,
    },
    {
        text: 'Calculating Assessment Results',
        detail: 'Please wait a moment longer...',
        duration: 6,
    },
    {
        text: 'Calculating Assessment Results',
        detail: 'Just a moment more...',
        duration: 6,
    },
    {
        text: 'Calculating Assessment Results',
        detail: 'Taking a bit longer than usual...',
        duration: 6,
    },
    {
        text: 'Calculating Assessment Results',
        detail: 'Something may have gone wrong.',
        showReload: true,
    },
];

export default {
    name: 'LoadingIcon',
    data() {
        return {
            timeoutId: null,
            messageIndex: 0,
            message: '\xa0',
            detail: '\xa0',
            showReload: false,
        };
    },
    computed: {
        checkPerformed() {
            return (location.search || '').indexOf('retryAttempted') >= 0;
        },
    },
    methods: {
        nextMessage() {
            const obj = messages[this.messageIndex];
            this.message = obj.text;
            this.detail = obj.detail;
            this.showReload = !!obj.showReload;
            if (obj.duration) {
                this.messageIndex++;
                this.timeoutId = setTimeout(this.nextMessage, obj.duration * 1000);
            }
        },
        handleReload() {
            if (this.checkPerformed) {
                window.location.reload();
            }
            else {
                window.location += '?retryAttempted=1';
            }
        },
    },
    mounted() {
        this.nextMessage();
    },
};
</script>